// @flow
import 'reactjs-popup/dist/index.css'

import { Tooltip as AntdTooltip } from 'antd'
import * as React from 'react'

export type TooltipPlacement =
  | 'top'
  | 'left'
  | 'right'
  | 'bottom'
  | 'topLeft'
  | 'topRight'
  | 'bottomLeft'
  | 'bottomRight'
  | 'leftTop'
  | 'leftBottom'
  | 'rightTop'
  | 'rightBottom'

export type Color =
  | 'pink'
  | 'red'
  | 'yellow'
  | 'orange'
  | 'cyan'
  | 'green'
  | 'blue'
  | 'purple'
  | 'geekblue'
  | 'magenta'
  | 'volcano'
  | 'gold'
  | 'lime'

type Props = {
  children: React.Node,
  label?: string | React.Node,
  title?: string | React.Node,
  arrow?: boolean | { pointAtCenter: boolean },
  placement?: TooltipPlacement,
  color?: Color | string,
  mouseEnterDelay?: number,
  enabled?: boolean,
  open?: boolean,
}

function Tooltip({
  label,
  title,
  arrow = true,
  placement,
  color = 'rgba(0, 0, 0)',
  mouseEnterDelay,
  enabled = true,
  open,
  children,
}: Props): React.Node {
  if (!enabled) return children

  return (
    <AntdTooltip
      arrow={arrow}
      classNames={{ root: 'text-xs' }}
      color={color}
      mouseEnterDelay={mouseEnterDelay}
      open={open}
      placement={placement}
      popupVisible={enabled}
      title={label || title}
    >
      {children}
    </AntdTooltip>
  )
}

export default Tooltip
